import { WINDOW_SIZE } from '../constants/constants';
export function windowSize() {
  if (window.innerWidth < WINDOW_SIZE.SMALL) {
    return WINDOW_SIZE.SMALL;
  } else if (window.innerWidth >= WINDOW_SIZE.LARGE) {
    return WINDOW_SIZE.LARGE;
  } else {
    return WINDOW_SIZE.MEDIUM;
  }
}
